import React, { useEffect, useState } from 'react';
import { Mail } from 'lucide-react';
import { toast } from 'sonner';
import { Switch } from '../../components/ui/switch';
import { api, errMsg } from '../api';
import { Card } from '../ui';

export default function MonitoringEmailPref({ className = 'mb-4' }) {
  const [on, setOn] = useState(null);
  useEffect(() => { api.get('/monitoring/prefs').then((r) => setOn(r.data.email)).catch(() => setOn(true)); }, []);
  const change = async (v) => {
    setOn(v);
    try { await api.put('/monitoring/prefs', { email: v }); toast.success(v ? 'Riceverai anche un\'email per ogni evento' : 'Solo notifiche nel portale'); } catch (e) { setOn(!v); toast.error(errMsg(e)); }
  };
  if (on === null) return null;
  return (
    <Card className={`p-5 ${className} flex items-center gap-4" `} data-testid="monitoring-email-pref">
      <Mail size={18} className="text-[#D4AF37] shrink-0" />
      <div className="flex-1"><p className="text-sm">Email per ogni evento</p><p className="text-xs text-[#8A8F97]">Monitoraggio aziende: gli eventi compaiono sempre nel portale (controllo giornaliero). Attiva per ricevere anche un'email BOND a ogni variazione.</p></div>
      <Switch checked={on} onCheckedChange={change} data-testid="monitoring-email-switch" />
    </Card>
  );
}

